/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  ReadAlertResponseDto,
  ReadAllAlertsResponseDto,
} from '.././model';

import { apiInstance } from '../../whisApi.instance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Mark all user alerts as read
 */
export const Alerts_markMultipleAsRead = (
  options?: SecondParameter<typeof apiInstance>,
) => {
  return apiInstance<ReadAllAlertsResponseDto>(
    { url: `/api/alerts/read`, method: 'PATCH' },
    options,
  );
};

export const getAlertsMarkMultipleAsReadMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof Alerts_markMultipleAsRead>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof Alerts_markMultipleAsRead>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['alertsMarkMultipleAsRead'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof Alerts_markMultipleAsRead>>,
    void
  > = () => {
    return Alerts_markMultipleAsRead(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AlertsMarkMultipleAsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof Alerts_markMultipleAsRead>>
>;

export type AlertsMarkMultipleAsReadMutationError = void;

/**
 * @summary Mark all user alerts as read
 */
export const useAlertsMarkMultipleAsRead = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof Alerts_markMultipleAsRead>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof Alerts_markMultipleAsRead>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getAlertsMarkMultipleAsReadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Mark an alert as read
 */
export const Alerts_markAsRead = (
  alertId: string,
  options?: SecondParameter<typeof apiInstance>,
) => {
  return apiInstance<ReadAlertResponseDto>(
    { url: `/api/alerts/${alertId}/read`, method: 'PATCH' },
    options,
  );
};

export const getAlertsMarkAsReadMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof Alerts_markAsRead>>,
    TError,
    { alertId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof Alerts_markAsRead>>,
  TError,
  { alertId: string },
  TContext
> => {
  const mutationKey = ['alertsMarkAsRead'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof Alerts_markAsRead>>,
    { alertId: string }
  > = (props) => {
    const { alertId } = props ?? {};

    return Alerts_markAsRead(alertId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AlertsMarkAsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof Alerts_markAsRead>>
>;

export type AlertsMarkAsReadMutationError = void;

/**
 * @summary Mark an alert as read
 */
export const useAlertsMarkAsRead = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof Alerts_markAsRead>>,
      TError,
      { alertId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof Alerts_markAsRead>>,
  TError,
  { alertId: string },
  TContext
> => {
  const mutationOptions = getAlertsMarkAsReadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
